module.exports = __webpack_public_path__ + "static/media/leftChevron.7a730708.svg";